// @flow
import { connect } from 'react-redux';

import {
  toggleDrawMode,
  setMode,
  drawingFinished,
  clear,
} from 'actions/drawOverlay';
import { toggleCoordinateInputDialog } from 'actions/coordinateInputDialog';
import { requestAnalysis } from 'actions/searchResultsDialog';
import {
  dndOverlaySetDndState,
  dndOverlaySetButtonVisible,
} from 'actions/dndOverlay';

import DrawToolbar from './DrawToolbar';

const mapStateToProps = ({
  drawOverlay: { appInDrawMode, drawToolsTourSeen, feature, mode },
  dndOverlay: { dndState },
  flags: { hasSubscription },
  browser,
}) => ({
  appInDrawMode,
  browser,
  drawToolsTourSeen,
  drawOverlayHasFeature: !!feature,
  drawOverlayMode: mode,
  dndState,
  hasSubscription,
});

const mapDispatchToProps = {
  setDrawOverlayMode: setMode,
  clearDrawOverlay: clear,

  toggleDrawMode,
  toggleCoordinateInputDialog,

  dndOverlaySetDndState,
  dndOverlaySetButtonVisible,

  requestAnalysis,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DrawToolbar);



// WEBPACK FOOTER //
// ./components/DrawToolbar/index.js